import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export const PaintSurchargeFields = ({ product, onChange }) => {
  const set = (k, v) => onChange({ ...product, [k]: v });
  return (
    <div className="border border-blue-200 bg-blue-50 p-4 space-y-4" data-testid="admin-paint-surcharge-section">
      <div>
        <Label className="font-mono text-xs uppercase text-blue-800">Supplément peinture multi-teintes (€)</Label>
        <Input type="number" min="0" value={product.paint_surcharge ?? 150}
          onChange={(e) => set('paint_surcharge', e.target.value)}
          className="mt-1 rounded-none border-blue-300 max-w-[200px]" data-testid="admin-paint-surcharge-input" />
        <p className="font-mono text-[10px] text-blue-700 mt-1">
          Appliqué dès que le client met au moins 2 teintes sur le cadre (vélo FOLGO et Kit Cadre FOLGO). Couleurs d'origine ou cadre d'une seule teinte : gratuit.
        </p>
      </div>
      <div className="flex items-center gap-2">
        <input type="checkbox" id="paint_promo_active" checked={product.paint_promo_active || false}
          onChange={(e) => set('paint_promo_active', e.target.checked)} className="rounded" data-testid="admin-paint-promo-toggle" />
        <Label htmlFor="paint_promo_active" className="font-mono text-xs uppercase text-blue-800">Activer une promo sur le supplément</Label>
      </div>
      {product.paint_promo_active && (
        <div>
          <Label className="font-mono text-xs uppercase text-blue-800">Prix promo du supplément (€)</Label>
          <Input type="number" min="0" value={product.paint_promo_price ?? ''} placeholder="Ex: 99"
            onChange={(e) => set('paint_promo_price', e.target.value)}
            className="mt-1 rounded-none border-blue-300 max-w-[200px]" data-testid="admin-paint-promo-input" />
          <p className="font-mono text-[10px] text-blue-700 mt-1">
            Le site affichera {product.paint_surcharge ?? 150} € barré. La promo reste active jusqu'à ce que vous la décochiez.
          </p>
        </div>
      )}
    </div>
  );
};
